import styled from "styled-components"

const TitleGroup = styled.hgroup`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.75em;
`

export { TitleGroup }
